export const AKOUO_SUPPORT_URL = 'https://akouo.io/support';
export const AKOUO_CONNECT_URL = 'https://akouo.io/connect-akouo';
export const ENTER_KEY_CODE = 13;
export const AKOUO_LOCAL_STORAGE = 'akouo';
